import { ChangeEvent, Dispatch, SetStateAction } from "react";
import InputLabel from "./InputLabel";
import { getFirefoxCssFix } from "../commonfunctions/getFirefoxCssFix";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import { inputFieldContent } from "./InputFieldContent";
import useTranslation from "../CustomHooks/useTranslation";

interface TextAreaProps {
  label?: string;
  placeholderRequied?: boolean;
  required?: boolean;
  text: string;
  setText: Dispatch<SetStateAction<string>>;
  textError: string;
  setTextError: Dispatch<SetStateAction<string>>;
  bgColor?: string;
  top?: string;
  maxLength?: number;
  disabled?: boolean;
  id?: string;
  height?: string;
}

export default function TextArea({
  label,
  placeholderRequied = true,
  top,
  required = true,
  text,
  id,
  setText,
  textError,
  setTextError,
  bgColor,
  disabled,
  maxLength = 250,
  height
}: TextAreaProps): JSX.Element {
  const { translate } = useTranslation(inputFieldContent)
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    setTextError("");
    let value = event.target.value;
    if (value.charAt(0) === " ") {
      value = value.trim();
    }

    // Restrict to a maximum of 250 characters
    if (value.length > maxLength) {
      value = value.substring(0, maxLength);
    }

    setText(value);
  };
  return (
    <div className={` ${top ? top : 'pt-3'}`}>
      <InputLabel id="reason" labelName={` ${label ? label : 'Reason'}`} required={required} marginBottom="mb-2" />
      <textarea
        data-testid={ id ||"description"}
        className={`w-full overflow-auto ${getFirefoxCssFix(
          "scroll"
        )} text-body2 ${textError ? "border-negative" : disabled ? "border-disable_stroke" : "border-P_light_active"
          } ${height || 'h-[100px]'} p-3 focus-within:p-[11px] border rounded-lg text-neutral-950 placeholder-neutral-400 ${bgColor ? bgColor : ''} resize-none focus:outline-none focus:border-2`}
        placeholder={placeholderRequied ? translate(`Enter the ${label ? label.toLocaleLowerCase() : 'reason'}`) : ''}
        value={text}
        onChange={handleChange}
        disabled={disabled}
      ></textarea>
      <div className={`relative  ${textError ? 'flex justify-between -top-[9px]' : '-top-2'}`}>
        {textError && <ErrorMessage errorMessage={textError} paddingTop={`${textError? 'pt-[2px]' : ''}`} />}
        <div className="text-right text-secondary_text mt-1 text-medium">
          {text.length}/{maxLength}
        </div>
      </div>
    </div>
  );
}
